import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const fetchBlogs = createAsyncThunk('blogsSlice/fetchBlogs', async () => {
    const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?blogs`)
    const data = await res.json()
    return data;
})

const blogsSlice = createSlice({
    initialState: {
        blogs: [],
        loading: false,
        error: null,
    },
    name: 'blogsSlice',
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlogs.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchBlogs.fulfilled, (state, action) => {
                state.loading = false;
                state.blogs = action.payload;
            })
            .addCase(fetchBlogs.rejected, (state, action) => {
                state.loading = false;
                state.error = <p className='error-api'>The server is temporarily down Please try later!</p>;
            });
    },
})

export const { } = blogsSlice.actions;

export default blogsSlice.reducer;